import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const LansingLugnutsLink = () => (
  <Link
    target="_blank"
    href="https://mlb.tickets.com/?agency=LLNM_MYTIXX&orgid=52790#"
    sx={{
      fontWeight: 500,
      color: "primary.main",
      textDecoration: "none",
    }}
  >
    MyProVenue
  </Link>
);

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to MiLB.com.",
    description:
      "Click Continue and connect your Lansing Lugnuts account using our secure MLB.com login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your <LansingLugnutsLink /> account within
        24 hours of purchase. Reach out to Live Fan Support or Lansing Lugnuts
        at{" "}
        <Link
          href="tel:5174854500x252"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          (517) 485-4500 x252
        </Link>{" "}
        for any questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Lansing Lugnuts Pick'em Plan work?",
    description:
      "The Lansing Lugnuts Pick'em Plan allows fans to select any seat to select games hosted by the Lansing Lugnuts. The more games you select the higher the discount on your tickets! Simply log into your MLB.com and select games.",
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description:
      "Yes, you can choose from all currently available Box Seat inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Tickets are delivered directly within your Lansing Lugnuts{" "}
        <LansingLugnutsLink /> Account.
      </>
    ),
  },
];
